import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import TextField from '@material-ui/core/TextField'
import StyleSheet from 'styles'
import {eventKeyMatches, KEYS} from 'utils'

export class EditableLabel extends PureComponent {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
  }

  static defaultProps = {
    classes: {}
  }

  constructor(props) {
    super(props)
    this.state = {
      value: this.props.value,
      editing: false
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value)
      this.setState({value: this.props.value})
  }

  handleClick = () => {
    this.setState({editing: true})
  }

  handleValueChange = ({target: {value}}) => {
    this.setState({value})
  }

  handleSave = () => {
    this.props.onChange({target: {value: this.state.value}})
    this.setState({editing: false})
  }

  handleCancel = () => {
    this.setState({
      value: this.props.value,
      editing: false
    })
  }

  handleKeyUp = (e) => {
    if (eventKeyMatches(e, KEYS.escape))
      this.handleCancel(e)
    else if (eventKeyMatches(e, KEYS.enter))
      this.handleSave(e)
  }

  render = () => {
    const {value, editing} = this.state
    const pending = (value !== this.props.value)
    return !editing ? <span onClick={this.handleClick} className={styles({label: true, pending})}>{value}</span> : (
      <TextField
        className={this.props.classes.input}
        value={value}
        onChange={this.handleValueChange}
        onBlur={this.handleSave}
        onKeyUp={this.handleKeyUp}
        autoFocus
      />
    )
  }
}

export default EditableLabel

const styles = StyleSheet({
  label: {
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  pending: {
    color: '#CCC'
  },
})